import { ButtonHTMLAttributes } from 'react'
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth'
import { GoogleIcon } from '../Icons/GoogleIcon'
import { AppleIcon } from '../Icons/AppleIcon'
import { SocialSignInButton } from './SocialButton'

type SocialButtons = ButtonHTMLAttributes<HTMLButtonElement> & {
  secondary?: boolean
  action: string
}

export const SocialButtons = ({ className, action }: SocialButtons) => {
  const googleMsg = `${action} with Google`
  const appleMsg = `${action} with Apple`
  return (
    <div className='flex flex-col gap-3'>
      <SocialSignInButton
        provider={CognitoHostedUIIdentityProvider.Google}
        Icon={GoogleIcon}
        className={className}
      >
        {googleMsg}
      </SocialSignInButton>

      <SocialSignInButton
        provider={CognitoHostedUIIdentityProvider.Apple}
        Icon={AppleIcon}
        className={className}
      >
        {appleMsg}
      </SocialSignInButton>
    </div>
  )
}
